import React, { useContext } from 'react';
import {
    BrandRow, BrandWrap, Column, DrawerRoot, FooterToggle, Gutter,
    LogoImg, LogoOnlyWrap, Product, RailScroll, ToggleBtn
} from "./sub_components";
import { Tooltip } from '@material-ui/core';
import { ChevronLeft as CollapseIcon, ChevronRight as ExpandIcon } from '@material-ui/icons';
import NavItems from './NavItems';
import { DRAWER_MINI, DRAWER_WIDTH } from './constants';
import { LayoutUIContex } from '../Layout/LayoutUIContext';

export default function Sidebar() {
    const {
        isDesktop,
        open, setOpen,
        pinned, togglePinned,
        collapsed,
        setHovering,
    } = useContext(LayoutUIContex);

    const isExpanded = !collapsed;
    const gutterWidth = isDesktop ? (isExpanded ? DRAWER_WIDTH : DRAWER_MINI) : 0;
    const drawerVariant = isDesktop ? 'permanent' : 'temporary';
    const drawerOpen = isDesktop ? true : Boolean(open);
    const paperWidth = isDesktop ? gutterWidth : DRAWER_WIDTH;

    const handleEnter = () => { if (isDesktop && !pinned) setHovering(true); };
    const handleLeave = () => { if (isDesktop) setHovering(false); };

    return (
        <>
            <Gutter $width={gutterWidth} aria-hidden />
            <DrawerRoot
                variant={drawerVariant}
                open={drawerOpen}
                onClose={isDesktop ? undefined : () => setOpen(false)}
                ModalProps={isDesktop ? undefined : { keepMounted: true }}
                PaperProps={{ style: { width: paperWidth } }}
            >
                <Column onMouseEnter={handleEnter} onMouseLeave={handleLeave}>
                    <BrandWrap>
                        {isExpanded ? (
                            <BrandRow>
                                <LogoImg src="/img/logo.png" alt="My SEO Toolbox" />
                                <Product>My SEO Toolbox</Product>
                            </BrandRow>
                        ) : (
                            <LogoOnlyWrap>
                                <LogoImg src="/img/logo.png" alt="My SEO Toolbox" />
                            </LogoOnlyWrap>
                        )}
                    </BrandWrap>

                    <RailScroll>
                        <NavItems/>
                    </RailScroll>

                    {isDesktop && (
                        <FooterToggle>
                            <Tooltip title={pinned ? 'Collapse' : 'Expand'} placement="top">
                                <ToggleBtn onClick={togglePinned} size="small" aria-label="Toggle sidebar">
                                    {pinned ? <CollapseIcon /> : <ExpandIcon />}
                                </ToggleBtn>
                            </Tooltip>
                        </FooterToggle>
                    )}
                </Column>
            </DrawerRoot>
        </>
    );
}
